﻿const element = document.querySelector('#custom-middle-navbar');
if (element) {
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            let force = entry.intersectionRatio < 1;
            entry.target.classList.toggle('shadow-xl', force);
        });

    }, { threshold: 1.0 });

    observer.observe(element);
}

const submenus = document.querySelectorAll('.calculated-height')

function calculateSubmenuHeight() {
  const top = document.querySelector('#top-navbar');
  const middle = document.querySelector('#custom-middle-navbar');

  const height = top.clientHeight + middle.clientHeight + 16;
  const windowHeight = window.innerHeight;
  const maxHeight = (windowHeight - height)
  submenus.forEach(submenu => { submenu.style.maxHeight = `${maxHeight}px`; })
}

document.addEventListener('DOMContentLoaded', function () {
  calculateSubmenuHeight();
});

window.addEventListener('resize', function () {
  calculateSubmenuHeight();
})